// src/utils/urlSlugs.js

/**
 * Minimal SEO slug utilities (slug-only URLs)
 */

// Create a SEO-friendly URL slug (Unicode-safe)
export const createUrlSlug = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text
    .normalize('NFD')                    // split base + diacritics
    .replace(/\p{Diacritic}/gu, '')      // strip diacritics
    .toLowerCase()
    .trim()
    .replace(/[_\s]+/g, '-')             // spaces/underscores -> hyphen
    .replace(/[^\p{Letter}\p{Number}-]+/gu, '') // keep letters/numbers/hyphen
    .replace(/-+/g, '-')                 // collapse hyphens
    .replace(/^-|-$/g, '');              // trim hyphens
};

// Create product URL from slug or name
export const createProductUrl = (slugOrName) => {
  const slug = createUrlSlug(slugOrName);
  return slug ? `/product/${slug}` : '/shop';
};

// Optional category URLs
export const createCategoryUrl = (categoryName) => {
  const slug = createUrlSlug(categoryName);
  return `/category/${slug}`;
};

export default {
  createUrlSlug,
  createProductUrl,
  createCategoryUrl,
};


// /**
//  * Minimal SEO slug utilities (slug-only URLs)
//  */

// // Create a SEO-friendly URL slug from any text (Unicode-safe)
// export const createUrlSlug = (text) => {
//   if (!text || typeof text !== 'string') return '';
//   return text
//     .normalize('NFD')                    // split base + diacritics
//     .replace(/\p{Diacritic}/gu, '')      // strip diacritics
//     .toLowerCase()
//     .trim()
//     .replace(/[_\s]+/g, '-')             // spaces/underscores -> hyphen
//     .replace(/[^\p{Letter}\p{Number}-]+/gu, '') // keep letters/numbers/hyphen
//     .replace(/-+/g, '-')                 // collapse hyphens
//     .replace(/^-|-$/g, '');              // trim hyphens
// };

// // Creates a product URL (slug or name)
// export const createProductUrl = (slugOrName) => {
//   const slug = createUrlSlug(slugOrName);
//   return slug ? `/product/${slug}` : '/shop';
// };

// // Optional category URL helper (keep only if used)
// export const createCategoryUrl = (categoryName) => {
//   const slug = createUrlSlug(categoryName);
//   return `/category/${slug}`;
// };

// // Compare a URL slug with a product name
// export const validateSlug = (slug, expectedName) =>
//   slug === createUrlSlug(expectedName);

// export default {
//   createUrlSlug,
//   createProductUrl,
//   createCategoryUrl,
//   validateSlug,
// };
